<nav class="navbar navbar-expand-lg bg-body-transparent p-0">
  <div class="container-fluid px-0">
    <a class="navbar-brand p-0" href="/">
      <img src="/angular/browser/img/header-logo-square.svg" />
    </a>
    <button
      class="navbar-toggler me-2"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse mt-auto" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="#">Csomagküldés</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Csomagküldés</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Csomagvisszaküldés</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Csomagautomaták</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Áraink</a>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Ügyfélszolgálat
          </a>
          <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" href="#">Gyakran Ismételt kérdések</a>
            </li>
            <li><a class="dropdown-item" href="#">Bejelentési űrlapok</a></li>
            <li>
              <a class="dropdown-item" href="#">Így Használd a foxpost-ot</a>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" aria-disabled="true" href="#">Webshop</a>
        </li>
      </ul>
      <div class="px-2">
        <a mat-flat-button href="/belepes" class="me-3 w-100 px-3">Belépés</a>
      </div>
    </div>
  </div>
</nav>
